
import { logger } from "@/services/LoggingService";

const COMPONENT = 'ImageOptimization';
const MAX_IMAGE_SIZE = 800;

export async function optimizeImage(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (width > MAX_IMAGE_SIZE || height > MAX_IMAGE_SIZE) {
        if (width > height) {
          height = Math.round(height * MAX_IMAGE_SIZE / width);
          width = MAX_IMAGE_SIZE;
        } else {
          width = Math.round(width * MAX_IMAGE_SIZE / height);
          height = MAX_IMAGE_SIZE;
        }
      }

      canvas.width = width;
      canvas.height = height;
      
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Failed to get canvas context'));
        return;
      }

      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Failed to create blob'));
          return;
        }
        
        const optimizedFile = new File([blob], file.name, {
          type: 'image/webp',
          lastModified: Date.now(),
        });

        logger.info(COMPONENT, 'Image optimized successfully', {
          originalSize: file.size,
          optimizedSize: optimizedFile.size,
          dimensions: `${width}x${height}`
        });
        
        resolve(optimizedFile);
      }, 'image/webp', 0.85);
    };

    img.onerror = () => {
      logger.error(COMPONENT, 'Failed to load image', {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type
      });
      reject(new Error('Failed to load image'));
    };
    img.src = URL.createObjectURL(file);
  });
}
